// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCompareFlyOutStyles } from "@vanmeter/Overrides/Components/ProductCompareFlyOut";
import IconClose from "@vanmeter/XDL/Icons/IconClose";
import { layoutContainer, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.slideItem = {
    css: css`
        max-width: 120px;
    `,
};

productCompareFlyOutStyles.carouselStyle = {
    container: {
        css: css`
            display: flex;
        `,
    },
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    size: 200,
    cssOverrides: {
        scrim: css`
            ${xScreen("lt", "sm")} {
                height: 135px;
            }
        `,
        drawerBody: css`
            width: 100%;
            padding: 0;
            ${xScreen("lt", "sm")} {
                top: auto;
                bottom: 0;
                height: 135px;
            }
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding-top: 0;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    variant: "primary",
    sizeVariant: "small",
};

productCompareFlyOutStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 10px;

        ${xScreen("lt", "md")} {
            flex-direction: row;
            width: 100%;
        }
    `,
};

productCompareFlyOutStyles.compareFlyOutWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 10px;
        ${layoutContainer}

        ${xScreen("lt", "md")} {
            gap: 0;
        }
    `,
};

productCompareFlyOutStyles.contentWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        gap: 15px;
        margin-bottom: 15px;

        ${xScreen("lt", "md")} {
            flex-direction: column;
            gap: 0;
        }
    `,
};

productCompareFlyOutStyles.itemsWrapper = {
    css: css`
        display: flex;
        gap: 10px;

        ${xScreen("lt", "md")} {
            display: none;
        }
    `,
};

productCompareFlyOutStyles.headerTitleText = {
    variant: "h3",
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    variant: "primary",
    buttonType: "outline",
    sizeVariant: "medium",
    css: css`
        ${xScreen("lt", "md")} {
            width: 100%;
        }
    `,
};

productCompareFlyOutStyles.headerCompareButton = {
    variant: "primary",
    buttonType: "solid",
    sizeVariant: "medium",
    css: css`
        ${xScreen("lt", "md")} {
            width: 100%;
        }
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButtonIcon = {
    src: IconClose,
    size: 10,
    css: css`
        margin-right: 5px;
    `,
};

productCompareFlyOutStyles.itemsCount = {
    variant: "h4",
    css: css`
        display: none;
        ${xScreen("lt", "md")} {
            display: block;
        }
    `,
};

productCompareFlyOutStyles.headerWrapper = {
    css: css`
        margin-top: 10px;
    `,
};
